export type SiteTextKind = "text" | "textarea" | "image";

export interface SiteTextDef {
  key: string;
  group: string;
  label: string;
  default: string;
  kind?: SiteTextKind;
  // Si se deja vacio, el sitio oculta ese elemento (en vez de exigir un valor).
  optional?: boolean;
  help?: string;
}

const IMG_CTA =
  "https://readdy.ai/api/search-image?query=Wide%20aerial%20view%20of%20a%20clean%20modern%20industrial%20warehouse%20park%20surrounded%20by%20deep%20green%20forest%20and%20lake%20in%20southern%20Chile%2C%20overcast%20soft%20daylight%2C%20muted%20earthy%20green%20and%20blue%20tones%2C%20premium%20architectural%20photography%2C%20no%20people%2C%20high%20detail%2C%20realistic&width=1600&height=900&seq=cta-bg&orientation=landscape";
const IMG_SEG_CAMARAS =
  "https://readdy.ai/api/search-image?query=Close%20up%20of%20modern%20security%20cameras%20mounted%20on%20building%20wall%20with%20LED%20lights%2C%20clean%20industrial%20warehouse%20exterior%2C%20dusk%20with%20warm%20lighting%2C%20southern%20Chile%2C%20premium%20photography%2C%20muted%20tones%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=seguridad-camaras&orientation=landscape";
const IMG_SEG_PORTON =
  "https://readdy.ai/api/search-image?query=Sturdy%20metal%20perimeter%20gate%20and%20fence%20of%20an%20industrial%20facility%20with%20access%20control%20reader%2C%20clean%20paved%20entrance%2C%20overcast%20daylight%2C%20southern%20Chile%20forest%20background%2C%20premium%20photography%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=seguridad-porton&orientation=landscape";
const IMG_SEG_LUZ =
  "https://readdy.ai/api/search-image?query=Well%20lit%20industrial%20warehouse%20yard%20at%20night%20with%20LED%20floodlights%20and%20storage%20unit%20doors%2C%20bright%20even%20lighting%2C%20clean%20concrete%20ground%2C%20southern%20Chile%2C%20premium%20night%20photography%2C%20muted%20tones%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=seguridad-iluminacion&orientation=landscape";
const IMG_SEG_MURO =
  "https://readdy.ai/api/search-image?query=Perimeter%20concrete%20wall%20enclosing%20an%20industrial%20warehouse%20park%20with%20barbed%20wire%20free%20clean%20design%2C%20green%20trees%20behind%2C%20overcast%20daylight%2C%20southern%20Chile%2C%20premium%20architectural%20photography%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=seguridad-muro&orientation=landscape";
const IMG_NOSOTROS =
  "https://readdy.ai/api/search-image?query=Modern%20clean%20industrial%20warehouse%20park%20at%20golden%20hour%20with%20rows%20of%20storage%20units%20and%20a%20large%20galpon%2C%20green%20forest%20and%20lake%20in%20background%2C%20southern%20Chile%2C%20warm%20natural%20light%2C%20premium%20architectural%20photography%2C%20no%20people%2C%20high%20detail&width=1200&height=800&seq=nosotros-equipo&orientation=landscape";

const G_MENU = "Encabezado (menú superior)";
const G_INT = "Páginas interiores (comunes)";
const G_PIE = "Pie de página";
const G_WA = "Botón flotante de WhatsApp";
const G_CTA = "Franja «Agenda una visita» (se repite en varias páginas)";
const G_HERO = "Inicio — Botones del banner principal";
const G_ENC = "Inicio — Encuentra tu espacio";
const G_COMO = "Inicio — Cómo funciona";
const G_UBI = "Inicio — Ubicación estratégica";
const G_TEST = "Inicio — Testimonios";
const G_FAQH = "Inicio — Preguntas frecuentes";
const G_BOD = "Bodegas — Catálogo";
const G_DET = "Bodegas — Detalle (ventana y página)";
const G_PLAN = "Planes (página)";
const G_UBIP = "Ubicación (página)";
const G_SEG = "Seguridad (página)";
const G_NOS = "Nosotros (página)";
const G_FAQP = "Preguntas frecuentes (página)";
const G_CONT = "Contacto (página)";
const G_WAMSG = "Mensajes de WhatsApp (texto que se carga al abrir el chat)";
const G_404 = "Página no encontrada (404)";
const G_MANT = "Pantalla de sitio en construcción";

export const SITE_TEXTS = [
  // ───────── Encabezado y pie ─────────
  { key: "comun.nav.bodegas", group: G_MENU, label: "Menú: Bodegas", default: "Bodegas" },
  { key: "comun.nav.planes", group: G_MENU, label: "Menú: Planes", default: "Planes y tamaños" },
  { key: "comun.nav.ubicacion", group: G_MENU, label: "Menú: Ubicación", default: "Ubicación" },
  { key: "comun.nav.seguridad", group: G_MENU, label: "Menú: Seguridad", default: "Seguridad" },
  { key: "comun.nav.nosotros", group: G_MENU, label: "Menú: Nosotros", default: "Nosotros" },
  { key: "comun.nav.faq", group: G_MENU, label: "Menú: Preguntas frecuentes", default: "FAQ" },
  { key: "comun.nav.contacto", group: G_MENU, label: "Menú en celular: Contacto", default: "Contacto" },
  { key: "comun.nav.boton", group: G_MENU, label: "Botón verde del menú", default: "Ver disponibilidad" },

  { key: "comun.footer.enlaces_titulo", group: G_PIE, label: "Título de la columna de enlaces", default: "Enlaces" },
  { key: "comun.footer.link_bodegas", group: G_PIE, label: "Enlace: bodegas", default: "Bodegas disponibles" },
  { key: "comun.footer.link_planes", group: G_PIE, label: "Enlace: planes", default: "Planes y tamaños" },
  { key: "comun.footer.link_ubicacion", group: G_PIE, label: "Enlace: ubicación", default: "Ubicación y recinto" },
  { key: "comun.footer.link_seguridad", group: G_PIE, label: "Enlace: seguridad", default: "Seguridad" },
  { key: "comun.footer.link_nosotros", group: G_PIE, label: "Enlace: nosotros", default: "Nosotros" },
  { key: "comun.footer.link_faq", group: G_PIE, label: "Enlace: preguntas frecuentes", default: "Preguntas frecuentes" },
  { key: "comun.footer.link_contacto", group: G_PIE, label: "Enlace: contacto", default: "Contacto" },
  { key: "comun.footer.contacto_titulo", group: G_PIE, label: "Título de la columna de contacto", default: "Contacto" },
  { key: "comun.footer.whatsapp_directo", group: G_PIE, label: "Texto del enlace de WhatsApp", default: "WhatsApp directo" },
  { key: "comun.horario.titulo", group: G_PIE, label: "Título de horarios (también en Contacto)", default: "Horario de atención" },
  { key: "comun.horario.lunes_viernes", group: G_PIE, label: "Horario: nombre de lunes a viernes (también en Contacto)", default: "Lunes a viernes" },
  { key: "comun.horario.sabado", group: G_PIE, label: "Horario: nombre del sábado (también en Contacto)", default: "Sábado" },
  { key: "comun.horario.acceso", group: G_PIE, label: "Horario: nombre del acceso a unidades (también en Contacto)", default: "Acceso unidades" },
  {
    key: "comun.footer.visitas",
    group: G_PIE,
    label: "Nota bajo los horarios",
    kind: "textarea",
    optional: true,
    default: "Visitas con cita previa. Te respondemos el mismo día hábil por WhatsApp.",
  },
  {
    key: "comun.footer.copyright",
    group: G_PIE,
    label: "Línea de derechos",
    default: "© {anio} {marca}. Todos los derechos reservados.",
    help: "{anio} se reemplaza por el año actual y {marca} por el nombre del negocio.",
  },
  { key: "comun.footer.terminos", group: G_PIE, label: "Enlace: términos y condiciones", default: "Términos y condiciones" },
  { key: "comun.footer.privacidad", group: G_PIE, label: "Enlace: política de privacidad", default: "Política de privacidad" },

  { key: "comun.migas_inicio", group: G_INT, label: "Ruta de navegación sobre el título de cada página: «Inicio»", default: "Inicio" },

  { key: "comun.whatsapp_flotante", group: G_WA, label: "Texto del botón flotante", default: "Cotizar por WhatsApp" },

  // ───────── Franja final ─────────
  { key: "comun.cta.titulo", group: G_CTA, label: "Título (se usa si la página no tiene uno propio)", default: "Agenda una visita esta semana" },
  {
    key: "comun.cta.descripcion",
    group: G_CTA,
    label: "Descripción (se usa si la página no tiene una propia)",
    kind: "textarea",
    default: "Cuéntanos qué necesitas y coordinamos un recorrido por el recinto. Te respondemos el mismo día hábil.",
  },
  { key: "comun.cta.boton_visita", group: G_CTA, label: "Botón de visita", default: "Solicitar visita" },
  { key: "comun.cta.boton_whatsapp", group: G_CTA, label: "Botón de WhatsApp", default: "Cotizar por WhatsApp" },
  { key: "comun.cta.nota", group: G_CTA, label: "Nota bajo los botones", optional: true, default: "Sin compromiso. Respondemos en menos de 24 horas." },
  { key: "comun.cta.imagen", group: G_CTA, label: "Imagen de fondo", kind: "image", optional: true, default: IMG_CTA },

  // ───────── Inicio ─────────
  { key: "home.hero.ubicacion", group: G_HERO, label: "Etiqueta sobre el título del banner", optional: true, default: "Puerto Varas · Región de Los Lagos" },
  { key: "home.hero.boton_bodegas", group: G_HERO, label: "Botón verde", default: "Ver bodegas" },
  { key: "home.hero.boton_whatsapp", group: G_HERO, label: "Botón de WhatsApp", default: "Cotizar por WhatsApp" },

  { key: "home.encuentra.etiqueta", group: G_ENC, label: "Etiqueta pequeña", optional: true, default: "Encuentra tu espacio" },
  { key: "home.encuentra.titulo", group: G_ENC, label: "Título", default: "Un tipo de unidad para cada necesidad" },
  {
    key: "home.encuentra.descripcion",
    group: G_ENC,
    label: "Descripción",
    kind: "textarea",
    optional: true,
    default: "Desde 12 m² para guardar stock hasta galpones de más de 2.000 m² para logística. Todos con seguridad 24/7 y acceso a la Ruta 5.",
  },
  { key: "home.encuentra.ver_detalle", group: G_ENC, label: "Enlace de cada tarjeta", default: "Ver detalle" },
  { key: "home.encuentra.cotizar", group: G_ENC, label: "Enlace de cotizar de cada tarjeta", default: "Cotizar" },
  { key: "home.encuentra.ver_catalogo", group: G_ENC, label: "Enlace al catálogo completo", default: "Ver catálogo completo" },

  { key: "home.como.etiqueta", group: G_COMO, label: "Etiqueta pequeña", optional: true, default: "Cómo funciona" },
  { key: "home.como.titulo", group: G_COMO, label: "Título", default: "De la consulta a tu unidad en 4 pasos" },
  {
    key: "home.como.descripcion",
    group: G_COMO,
    label: "Descripción",
    kind: "textarea",
    optional: true,
    default: "Sin trámites eternos. La mayoría de nuestros clientes entra a su bodega en menos de una semana.",
  },
  { key: "home.como.boton", group: G_COMO, label: "Botón", default: "Agenda tu visita" },

  { key: "home.ubicacion.etiqueta", group: G_UBI, label: "Etiqueta pequeña", optional: true, default: "Ubicación estratégica" },
  { key: "home.ubicacion.titulo", group: G_UBI, label: "Título", default: "A minutos de Puerto Varas y Puerto Montt" },
  {
    key: "home.ubicacion.descripcion",
    group: G_UBI,
    label: "Descripción",
    kind: "textarea",
    optional: true,
    default:
      "Estamos junto a la Ruta 5 Sur, con conexión rápida a Llanquihue y al aeropuerto El Tepual. Ideal para mover mercadería entre Puerto Montt, Puerto Varas y toda la Región de Los Lagos.",
  },
  {
    key: "home.ubicacion.lista",
    group: G_UBI,
    label: "Lista de tiempos (una línea por ítem)",
    kind: "textarea",
    optional: true,
    default: "Puerto Varas centro — 10 min\nPuerto Montt — 20 min\nAeropuerto El Tepual — 25 min\nLlanquihue — 15 min",
  },
  { key: "home.ubicacion.boton", group: G_UBI, label: "Botón", default: "Ver ubicación y cómo llegar" },

  { key: "home.testimonios.etiqueta", group: G_TEST, label: "Etiqueta pequeña", optional: true, default: "Clientes del sur" },
  { key: "home.testimonios.titulo", group: G_TEST, label: "Título", default: "Empresas que ya operan con nosotros" },

  { key: "home.faq.etiqueta", group: G_FAQH, label: "Etiqueta pequeña", optional: true, default: "Preguntas frecuentes" },
  { key: "home.faq.titulo", group: G_FAQH, label: "Título", default: "Lo que más nos preguntan" },
  { key: "home.faq.ver_todas", group: G_FAQH, label: "Enlace a todas las preguntas", default: "Ver todas las preguntas" },

  // ───────── Bodegas ─────────
  { key: "bodegas.filtro_todas", group: G_BOD, label: "Filtro: todas", default: "Todas" },
  { key: "bodegas.filtro_mini", group: G_BOD, label: "Filtro: mini bodegas", default: "Mini bodegas" },
  { key: "bodegas.filtro_bodega", group: G_BOD, label: "Filtro: bodegas", default: "Bodegas" },
  { key: "bodegas.filtro_galpon", group: G_BOD, label: "Filtro: galpones", default: "Galpones" },
  { key: "bodegas.con_oficina", group: G_BOD, label: "Casilla: con oficina", default: "Con oficina" },
  { key: "bodegas.disponible_ahora", group: G_BOD, label: "Casilla: disponible ahora", default: "Disponible ahora" },
  {
    key: "bodegas.mostrando",
    group: G_BOD,
    label: "Contador de unidades",
    default: "Mostrando {n} de {total} unidades",
    help: "{n} es la cantidad que se ve y {total} la cantidad total.",
  },
  { key: "bodegas.badge_disponible", group: G_BOD, label: "Etiqueta: disponible", default: "Disponible" },
  { key: "bodegas.badge_ocupado", group: G_BOD, label: "Etiqueta: ocupado", default: "Ocupado" },
  { key: "bodegas.precio_desde", group: G_BOD, label: "Precio: palabra antes del valor", default: "Desde" },
  { key: "bodegas.precio_sufijo", group: G_BOD, label: "Precio: texto después del valor", default: "/ mes + IVA" },
  { key: "bodegas.ver_detalle", group: G_BOD, label: "Enlace de cada tarjeta", default: "Ver detalle" },
  { key: "bodegas.consultar", group: G_BOD, label: "Enlace de consultar de cada tarjeta", default: "Consultar" },
  { key: "bodegas.vacio", group: G_BOD, label: "Mensaje cuando no hay resultados", default: "No encontramos unidades con esos filtros." },
  { key: "bodegas.limpiar_filtros", group: G_BOD, label: "Enlace para limpiar filtros", default: "Limpiar filtros" },
  { key: "bodegas.cta_titulo", group: G_BOD, label: "Recuadro final: título", default: "¿No encuentras el tamaño que necesitas?" },
  {
    key: "bodegas.cta_descripcion",
    group: G_BOD,
    label: "Recuadro final: descripción",
    kind: "textarea",
    optional: true,
    default: "Tenemos unidades adicionales y podemos armar soluciones a medida según tu operación.",
  },
  { key: "bodegas.cta_boton_whatsapp", group: G_BOD, label: "Recuadro final: botón de WhatsApp", default: "Cotizar un tamaño específico" },
  { key: "bodegas.cta_boton_visita", group: G_BOD, label: "Recuadro final: botón de visita", default: "Solicitar visita" },

  { key: "bodegas.detalle.whatsapp", group: G_DET, label: "Botón de WhatsApp", default: "Consultar por WhatsApp" },
  { key: "bodegas.detalle.formulario", group: G_DET, label: "Botón al formulario", default: "Ir al formulario de contacto" },
  { key: "bodegas.detalle.volver", group: G_DET, label: "Enlace para volver (solo en la página de detalle)", default: "← Volver al catálogo" },
  { key: "bodegas.detalle.migas_bodegas", group: G_DET, label: "Ruta de navegación: bodegas", default: "Bodegas" },

  // ───────── Planes ─────────
  { key: "planes.ideal_para", group: G_PLAN, label: "Subtítulo «Ideal para»", default: "Ideal para" },
  { key: "planes.incluye", group: G_PLAN, label: "Subtítulo «Incluye»", default: "Incluye" },
  { key: "planes.cotizar", group: G_PLAN, label: "Botón de cotizar", default: "Cotizar este plan" },
  { key: "planes.ver_unidades", group: G_PLAN, label: "Botón de ver unidades", default: "Ver unidades disponibles" },
  { key: "planes.info1_titulo", group: G_PLAN, label: "Recuadro 1: título", default: "UF + IVA" },
  { key: "planes.info1_texto", group: G_PLAN, label: "Recuadro 1: texto", kind: "textarea", default: "Todos los valores se cotizan en Unidades de Fomento, con IVA según corresponda." },
  { key: "planes.info2_titulo", group: G_PLAN, label: "Recuadro 2: título", default: "3 – 24 meses" },
  { key: "planes.info2_texto", group: G_PLAN, label: "Recuadro 2: texto", kind: "textarea", default: "Plazos flexibles según el tipo de unidad y tus necesidades de operación." },
  { key: "planes.info3_titulo", group: G_PLAN, label: "Recuadro 3: título", default: "Medidores propios" },
  { key: "planes.info3_texto", group: G_PLAN, label: "Recuadro 3: texto", kind: "textarea", default: "Pagas solo la luz y el agua que consumes, con medición independiente por unidad." },

  // ───────── Ubicación ─────────
  { key: "ubicacion.etiqueta", group: G_UBIP, label: "Etiqueta pequeña", optional: true, default: "Dónde estamos" },
  { key: "ubicacion.titulo", group: G_UBIP, label: "Título", default: "Acceso directo desde la Ruta 5 Sur" },
  {
    key: "ubicacion.descripcion",
    group: G_UBIP,
    label: "Descripción",
    kind: "textarea",
    optional: true,
    default:
      "Nuestra ubicación es una de las principales ventajas del recinto: conectas en minutos con Puerto Varas, Puerto Montt, Llanquihue y el aeropuerto. Menos tiempo en traslados, más tiempo operando.",
  },
  { key: "ubicacion.boton_whatsapp", group: G_UBIP, label: "Botón de WhatsApp", default: "Agendar visita por WhatsApp" },
  { key: "ubicacion.boton_visita", group: G_UBIP, label: "Botón de visita", default: "Solicitar visita" },
  { key: "ubicacion.rutas_etiqueta", group: G_UBIP, label: "Sección de rutas: etiqueta", optional: true, default: "Cómo llegar" },
  { key: "ubicacion.rutas_titulo", group: G_UBIP, label: "Sección de rutas: título", default: "Rutas recomendadas" },

  // ───────── Seguridad ─────────
  { key: "seguridad.etiqueta", group: G_SEG, label: "Etiqueta pequeña", optional: true, default: "Protección real" },
  { key: "seguridad.titulo", group: G_SEG, label: "Título", default: "Lo que guardas, queda protegido" },
  {
    key: "seguridad.descripcion",
    group: G_SEG,
    label: "Descripción",
    kind: "textarea",
    optional: true,
    default:
      'Entendemos que para una pyme o una empresa de logística, la seguridad no es un "plus": es un requisito. Por eso el recinto combina tecnología, control físico y presencia humana.',
  },
  { key: "seguridad.bloque_titulo", group: G_SEG, label: "Bloque oscuro: título", default: "Pensado para que duermas tranquilo" },
  {
    key: "seguridad.bloque_descripcion",
    group: G_SEG,
    label: "Bloque oscuro: descripción",
    kind: "textarea",
    optional: true,
    default:
      "Muchos clientes nos dicen que lo que más valoran es poder olvidarse de su bodega y concentrarse en su negocio. Con cámaras, control de acceso y vigilancia activa, tu mercadería queda resguardada mientras tú operas.",
  },
  { key: "seguridad.boton_preguntar", group: G_SEG, label: "Bloque oscuro: botón de WhatsApp", default: "Preguntar por seguridad" },
  { key: "seguridad.boton_visita", group: G_SEG, label: "Bloque oscuro: botón de visita", default: "Agendar visita" },
  { key: "seguridad.foto1", group: G_SEG, label: "Foto 1 (arriba a la izquierda)", kind: "image", optional: true, default: IMG_SEG_CAMARAS },
  { key: "seguridad.foto1_alt", group: G_SEG, label: "Foto 1: descripción", optional: true, default: "Cámaras de seguridad en el recinto" },
  { key: "seguridad.foto2", group: G_SEG, label: "Foto 2 (arriba a la derecha)", kind: "image", optional: true, default: IMG_SEG_PORTON },
  { key: "seguridad.foto2_alt", group: G_SEG, label: "Foto 2: descripción", optional: true, default: "Portón principal con control de acceso" },
  { key: "seguridad.foto3", group: G_SEG, label: "Foto 3 (abajo a la izquierda)", kind: "image", optional: true, default: IMG_SEG_LUZ },
  { key: "seguridad.foto3_alt", group: G_SEG, label: "Foto 3: descripción", optional: true, default: "Iluminación LED nocturna del recinto" },
  { key: "seguridad.foto4", group: G_SEG, label: "Foto 4 (abajo a la derecha)", kind: "image", optional: true, default: IMG_SEG_MURO },
  { key: "seguridad.foto4_alt", group: G_SEG, label: "Foto 4: descripción", optional: true, default: "Cierre perimetral del recinto" },

  // ───────── Nosotros ─────────
  { key: "nosotros.etiqueta", group: G_NOS, label: "Etiqueta pequeña", optional: true, default: "Quiénes somos" },
  { key: "nosotros.titulo", group: G_NOS, label: "Título", default: "Un operador local que entiende la logística del sur" },
  { key: "nosotros.foto", group: G_NOS, label: "Foto", kind: "image", optional: true, default: IMG_NOSOTROS },
  { key: "nosotros.foto_alt", group: G_NOS, label: "Foto: descripción", optional: true, default: "Recinto industrial de ESPACIO BORMAN al atardecer" },
  { key: "nosotros.valores_etiqueta", group: G_NOS, label: "Sección de valores: etiqueta", optional: true, default: "Lo que nos mueve" },
  { key: "nosotros.valores_titulo", group: G_NOS, label: "Sección de valores: título", default: "Tres principios en cada unidad" },
  { key: "nosotros.boton_whatsapp", group: G_NOS, label: "Recuadro final: botón de WhatsApp", default: "Escribir por WhatsApp" },
  { key: "nosotros.boton_formulario", group: G_NOS, label: "Recuadro final: botón al formulario", default: "Ir al formulario de contacto" },

  // ───────── Preguntas frecuentes ─────────
  { key: "faq.otra_titulo", group: G_FAQP, label: "Recuadro «otra pregunta»: título", default: "¿Tienes otra pregunta?" },
  {
    key: "faq.otra_descripcion",
    group: G_FAQP,
    label: "Recuadro «otra pregunta»: descripción",
    kind: "textarea",
    optional: true,
    default: "Te respondemos el mismo día hábil. Escríbenos y conversemos sobre tu caso particular.",
  },
  { key: "faq.boton_whatsapp", group: G_FAQP, label: "Botón de WhatsApp", default: "Preguntar por WhatsApp" },
  { key: "faq.boton_formulario", group: G_FAQP, label: "Botón al formulario", default: "Ir al formulario" },

  // ───────── Contacto ─────────
  { key: "contacto.card_whatsapp", group: G_CONT, label: "Tarjeta de WhatsApp: título", default: "WhatsApp" },
  { key: "contacto.card_telefono", group: G_CONT, label: "Tarjeta de teléfono: título", default: "Teléfono" },
  { key: "contacto.card_email", group: G_CONT, label: "Tarjeta de email: título", default: "Email" },

  // ───────── Mensajes de WhatsApp ─────────
  {
    key: "wa.cotizar_bodega",
    group: G_WAMSG,
    label: "Al cotizar una bodega",
    default: "Hola, quiero cotizar la {nombre} en Puerto Varas",
    help: "{nombre} se reemplaza por el nombre de la bodega.",
  },
  {
    key: "wa.cotizar_plan",
    group: G_WAMSG,
    label: "Al cotizar un plan",
    default: "Hola, quiero cotizar {nombre} en Puerto Varas",
    help: "{nombre} se reemplaza por el nombre del plan.",
  },
  { key: "wa.agendar_visita", group: G_WAMSG, label: "Al agendar una visita", default: "Hola, quiero agendar una visita al recinto en Puerto Varas" },
  { key: "wa.seguridad", group: G_WAMSG, label: "Al preguntar por seguridad", default: "Hola, quiero conocer los detalles de seguridad del recinto en Puerto Varas" },
  { key: "wa.faq", group: G_WAMSG, label: "Al hacer otra pregunta", default: "Hola, tengo una consulta sobre el arriendo de bodegas en Puerto Varas" },

  // ───────── 404 y mantenimiento ─────────
  { key: "notfound.titulo", group: G_404, label: "Título", default: "Esta página no existe" },
  {
    key: "notfound.texto",
    group: G_404,
    label: "Texto",
    kind: "textarea",
    optional: true,
    default: "Puede que el enlace esté roto o que la página se haya movido. Vuelve al inicio o revisa nuestro catálogo de bodegas disponibles.",
  },
  { key: "notfound.boton_inicio", group: G_404, label: "Botón de inicio", default: "Volver al inicio" },
  { key: "notfound.enlace_bodegas", group: G_404, label: "Enlace a bodegas", default: "Ver bodegas disponibles" },

  { key: "mantenimiento.titulo", group: G_MANT, label: "Título", default: "Sitio en construcción" },
  {
    key: "mantenimiento.texto",
    group: G_MANT,
    label: "Texto",
    kind: "textarea",
    optional: true,
    default: "Estamos trabajando en nuestra página. Pronto estará activa.",
  },
] as const satisfies readonly SiteTextDef[];

export type SiteTextKey = (typeof SITE_TEXTS)[number]["key"];

const DEFAULTS: Record<string, string> = Object.fromEntries(SITE_TEXTS.map((d) => [d.key, d.default]));

export function interpolate(text: string, vars?: Record<string, string | number>): string {
  if (!vars) return text;
  return text.replace(/\{(\w+)\}/g, (match, name) => (name in vars ? String(vars[name]) : match));
}

export function resolveSiteText(
  overrides: Record<string, string> | undefined,
  key: SiteTextKey,
  vars?: Record<string, string | number>
): string {
  const value = overrides && typeof overrides[key] === "string" ? overrides[key] : DEFAULTS[key];
  return interpolate(value, vars);
}
